import { getStore } from './store'

export function addDonorToTrackingSegment (donorId, postId, segmentId) {
  const adminServiceUrl = getStore().getState().config.adminServiceUrl;
  const charityId = getStore().getState().config.charityId;
  let url = new URL(`${adminServiceUrl}/api/v1/${charityId}/trackingSegment`);
  let params = { donorId: donorId, postId: postId, segmentId: segmentId };
  url.search = new URLSearchParams(params).toString();

  fetch(url, {
    method: 'GET',
    mode: 'no-cors'
  })
}

export function trackMmsLinkClick (postId, publicDonorId) {
  const adminServiceUrl = getStore().getState().config.adminServiceUrl;
  const charityId = getStore().getState().config.charityId;
  let url = new URL(`${adminServiceUrl}/api/v1/${charityId}/trackMMSClick`);
  let params = { postId: postId, publicDonorId: publicDonorId };
  url.search = new URLSearchParams(params).toString();

  fetch(url, {
    method: 'GET',
    mode: 'no-cors'
  })
}
